import type { Period } from '@/utilities/timeSeriesPeriodMap';

export const CURRENT_PERIOD: Period = '1Y';
